// extracted by mini-css-extract-plugin
module.exports = {"boonActivated":"TamaGawdtchiHealth_boonActivated__8iBYc","boon-activated":"TamaGawdtchiHealth_boon-activated__BlxVz"};